import axios from 'axios'

const INPOST_API_URL = process.env.REACT_APP_INPOST_API_URL

export const inpostApi = () => axios.create({ baseURL: INPOST_API_URL })
